import React from "react";
import emojiSprite from "../../../assets/sheet_facebook_32.png";

export default function EmojiItem({ emoji, onSelect }) {
    const spriteCols = 62;
    const backgroundSize = `${spriteCols * 100}% auto`;

    const style = {
        width: 28,
        height: 28,
        backgroundImage: `url(${emojiSprite})`,
        backgroundSize,
        backgroundPosition: `${(emoji.x / (spriteCols - 1)) * 100}% ${(emoji.y / (spriteCols - 1)) * 100}%`,
        backgroundRepeat: "no-repeat",
        cursor: "pointer",
    };

    return <div style={style} onClick={onSelect} title={emoji.name} />;
}
